import { useCallback, useEffect, useState } from 'react';
import { companiesApi } from '@/api/companies.api';
import type { CompanyResponse } from '@/types/company';
import { showApiError } from '@/utils/apiError';

export function useActiveCompanies() {
  const [companies, setCompanies] = useState<CompanyResponse[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const list = await companiesApi.listAccessible();
      setCompanies(list);
    } catch (err) {
      showApiError(err, 'Failed to load companies');
      setCompanies([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { companies, loading, reload };
}
